module.exports = __webpack_public_path__ + "img/santa-mobile.3e308fe3.svg";